/**
 * @name background
 */

export const background = ({ position, size, repeat } = {}) => `
    background-position: ${position || 'center'};
    background-size: ${size || 'cover'};
    background-repeat: ${repeat || 'no-repeat'};
`;
